<template>
  <div class="query-com">
    <Select
      src="oldclassic_m_rank_paihangbang"
      :op="rank_type"
      label="排行榜"
      v-model:selectValue="filter_op.order_key"
      v-if="!is_search"
      @opChange="value = opChange('order_key', value)"
    />

    <Select
      src="oldclassic_m_rank_menpai"
      :op="school_op"
      label="门派"
      v-model:selectValue="filter_op.school"
      @opChange="value = opChange('school', value)"
    />

    <Select
      src="oldclassic_m_rank_fueuqi-daqv"
      :op="sector_op"
      label="服务器"
      v-model:selectValue="sector"
    />

    <div class="between">
      <Select
        src="oldclassic_m_rank_suoyoufuwuqi"
        :op="server_op"
        v-model:selectValue="filter_op.server"
        @opChange="value = opChange('server', value)"
      />

      <TxBtn src="oldclassic_m_rank_query" @click="doQuery" v-if="!is_search" />
    </div>
    <!-- <TxBtn src="rank_fanhui" v-if="!is_search" /> -->
  </div>
</template>

<script setup>
import Select from './Select.vue';

const { is_mobile, schools, sectors, rank_type } = inject('GlobalStore');

const props = defineProps({
  is_search: {
    type: Boolean,
    default: false,
  },
  default_values: {
    type: Object,
    default: () => ({}),
  },
});

const filter_op = ref({
  school: '',
  server: '',
  order_key: 'total_xiuwei',
  //   sector: '',
});

const emit = defineEmits(['do_query', 'op_change']);

const sector = ref('');

const school_op = computed(() => {
  const tmp = Object.entries(schools.value).map(([value, text]) => {
    return { text, value };
  });
  tmp.unshift({ text: '所有门派', value: '' });
  return tmp;
});

const sector_op = computed(() => {
  const sector_list = [];
  Object.entries(sectors.value).map(([_server, _sector]) => {
    if (sector_list.indexOf(_sector) === -1) {
      sector_list.push(_sector);
    }
    return item;
  });

  const tmp = sector_list.map((item) => {
    return { text: item, value: item };
  });
  tmp.unshift({ text: '所有大区', value: '' });
  return tmp;
});

const server_op = computed(() => {
  let server_list = [];
  if (sector.value === '') {
    server_list = [{ text: '所有服务器', value: '' }];
    Object.entries(sectors.value).map(([_server, _sector]) => {
      server_list.push({ text: _server, value: _server });
    });
  } else {
    Object.entries(sectors.value).map(([_server, _sector]) => {
      if (_sector === sector.value) {
        server_list.push({ text: _server, value: _server });
      }
    });
  }

  if (server_list.length === 0) {
    server_list = [{ text: '所有服务器', value: '' }];
  }

  if (
    server_list.findIndex((item) => item.value === filter_op.value.server) ===
    -1
  ) {
    // 服务器不在大区内， 默认选择大区的第一个服务器
    filter_op.value.server = server_list.at(0).value;
  }

  return server_list;
});

const doQuery = () => {
  emit('do_query', filter_op.value);
};

const opChange = (key, value) => {
  emit('op_change', filter_op.value);
};

onMounted(() => {
  console.log('onMounted default_values', props.default_values);
  if (props.default_values.school) {
    filter_op.value.school = props.default_values.school;
  }
  if (props.default_values.server) {
    filter_op.value.server = props.default_values.server;
    sector.value = sectors.value[props.default_values.server]?.sector;
  }
  if (props.default_values.order_key) {
    filter_op.value.order_key = props.default_values.order_key;
  }
});
</script>